import { EVENT_VIEW_COMPLEMENTARY } from '~~/constants/googleTagManager';

export const buildViewComplementaryTags = (items: string[]) => ({
  event: EVENT_VIEW_COMPLEMENTARY,
  items: {
    complementary_count: items.length,
    complementary_ids: items,
  },
});
